var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationEditorMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 406,
    height: 331,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "27.846%",
    x2: "100%",
    y2: "72.154%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F71",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3E55",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "41.623%",
    x2: "100%",
    y2: "58.377%",
    id: "e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F71",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3E55",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-21.5%",
    y: "-23%",
    width: "142.9%",
    height: "164.5%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 20,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.421821759 0 0 0 0 0.554338424 0 0 0 0 0.893710371 0 0 0 0.243444056 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "a",
    x: 0,
    y: 0,
    width: 326,
    height: 217,
    rx: 5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#2D2E40",
    opacity: 0.08,
    transform: "matrix(1 0 0 -1 0 329)",
    x: 52,
    y: 53,
    width: 223,
    height: 223,
    rx: 111.5
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#2D2E40",
    opacity: 0.5,
    transform: "matrix(1 0 0 -1 0 326)",
    x: 37.5,
    y: 37.5,
    width: 251,
    height: 251,
    rx: 125.5
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#2D2E40",
    opacity: 0.25,
    transform: "matrix(1 0 0 -1 0 326)",
    x: 0.5,
    y: 0.5,
    width: 325,
    height: 325,
    rx: 162.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40 54)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#c)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3 63.525h320a3 3 0 013 3V214a3 3 0 01-3 3H3a3 3 0 01-3-3V66.525a3 3 0 013-3z",
    fill: "#2D2E40",
    fillRule: "nonzero",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#d)",
    x: 45.967,
    y: 24.246,
    width: 68.95,
    height: 69.707,
    rx: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2D2E40",
    mask: "url(#d)",
    cx: 80.442,
    cy: 59.402,
    rx: 19.959,
    ry: 20.003
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#d)",
    x: 126.408,
    y: 24.246,
    width: 153.625,
    height: 165.478,
    rx: 3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106 144c23.871-37.394 41.526-57.6 52.964-60.62 17.158-4.53 12.04 42.374 36.744 36.938 24.705-5.436 27.717-52.994 46.403-55.234 18.685-2.241 28.57 41.257 36.733 45.264 5.441 2.672 12.16-3.105 20.156-17.332",
    stroke: "url(#e)",
    strokeWidth: 8,
    strokeLinecap: "round",
    transform: "translate(40 54)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEditorMobile);
export default __webpack_public_path__ + "static/media/illustration-editor-mobile.b9c7941a96d06832fa27673be37499a4.svg";
export { ForwardRef as ReactComponent };